import { render, staticRenderFns } from "./UnitTypeEdit.vue?vue&type=template&id=31dcf15a&"
import script from "./UnitTypeEdit.vue?vue&type=script&lang=js&"
export * from "./UnitTypeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports